export default "__VITE_ASSET__51ddeb15__"